import { __localesModel, __localizedField } from "@/Utils/locales";
const __DateOptions = {
  startDate: null,
  endDate: null
};
export const models = {
  locales: __localesModel,
  dateRange: { ...__DateOptions }
};
export const options = {};

export const Fields = [
  __localizedField,
  {
    label: "Date range",
    name: "dateRange",
    placeholder: "Select the start date",
    type: "date-range",
    value: "",
    format: "dd-mm-yyyy HH:mm:ss",
    rules: "required",
    validationMessage: {
      required: "This field is required"
    },
    xl: "12"
  }
];
